import React from "react";
import { Link } from "react-router-dom";
import "./LegalPage.css";

function OnyxAIPrivacy() {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <div className="legal-header-content">
          <img src="/images/onyxai_logo.png" alt="OnyxAI Logo" />
          <div>
            <h1>OnyxAI Privacy Policy</h1>
            <p>Virtual Photo Studio</p>
          </div>
        </div>
        <Link to="/" className="legal-back-link">← Back to OnyxUp</Link>
      </div>

      <div className="legal-content">
          <h2>Privacy Policy</h2>
          <p><strong>Last Updated:</strong> 29 September 2025</p>
          
          <h3>1. Introduction and Scope</h3>
          <p>Onyx AI ("we", "our", "us") values your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, store, and delete data when you use the Onyx AI app ("App").</p>
          
          <h3>2. User Eligibility</h3>
          <p>This App is intended for users aged 18 years and older. By using Onyx AI you confirm you meet this age requirement.</p>
          
          <h3>3. Information We Collect</h3>
          <p><strong>Camera & Image Data:</strong></p>
          <ul>
            <li>We request access to your device camera to capture photos for generating AI-powered content.</li>
            <li>Images are transmitted to our processing services only with your consent.</li>
            <li>These images are processed temporarily for AI content creation.</li>
            <li>No facial recognition or biometric data is collected.</li>
            <li>Images are not stored, retained, or analyzed. Once processed, all images are immediately deleted.</li>
          </ul>
          
          <p><strong>User Content:</strong></p>
          <ul>
            <li>Images or generated outputs you choose to save are stored locally on your device or in your account (if the feature is provided) and remain under your control.</li>
            <li>We do not store photos or any other content beyond this scope.</li>
          </ul>
          
          <p><strong>Technical & Usage Data:</strong></p>
          <ul>
            <li>We may collect anonymous, aggregated technical data (device model, OS version, app usage patterns) solely to improve performance and security.</li>
            <li>This does not include personally identifiable information.</li>
          </ul>
          
          <h3>4. Third-Party Processing and Retention</h3>
          <p>We may use trusted third-party services to process images and provide features (for example: Replicate API for model inference, Google Cloud for temporary storage). All transfers use encrypted channels (HTTPS). Uploaded images are deleted from our systems and third-party processors within 24 hours after processing, unless you explicitly save them.</p>
          
          <h3>5. How We Use Your Information</h3>
          <p>We use collected information to provide, maintain, and improve App features, for security, and to comply with legal obligations. We do not sell or rent personal data to third parties.</p>
          
          <h3>6. Your Rights</h3>
          <p>You may request deletion of your data at any time by contacting us (see contact below). We will respond and process deletion requests within a reasonable timeframe and may ask for identity verification to honor the request.</p>
          
          <h3>7. Security</h3>
          <p>We implement reasonable technical and organizational measures to protect data. However, no system is completely secure; we cannot guarantee absolute security.</p>
          
          <h3>8. Changes to this Policy</h3>
          <p>We may update this Policy from time to time; material changes will be posted on this page with an updated "Last Updated" date.</p>
          
          <h3>9. Contact</h3>
          <p>For questions, data deletion requests or other inquiries, contact us at:</p>
          <p>📧 onyxai.hub@gmail.com</p>
          
          <h3>10. Face Data</h3>
          <p>The app does not collect or store any facial data. User-uploaded images are processed temporarily to generate AI-powered content and deleted immediately after processing. No facial recognition or biometric data is stored or shared.</p>
          
          <h3>11. Privacy Policy URL</h3>
          <p>Privacy Policy URL: 🔗 <a href="https://www.onyxup.net/terms">https://www.onyxup.net/terms</a></p>
      </div>
    </div>
  );
}

export default OnyxAIPrivacy;

